/**
 * Hook: useFetchGenericRQScoringConfig
 *
 * Fetches the per-research-query generic-RQ scoring config override (if any).
 * Mirrors useFetchValidationScoringConfig and useFetchComparisonScoringConfig.
 */
import { useEffect, useState } from "react";
import { IGenericRQScoringConfig } from "../types/Scoring.type";
import { getGenericRQScoringConfigByQuery } from "../services/scoringService";

interface IuseFetchGenericRQScoringConfig {
  setIsLoading: any;
  queryId: any;
}

const useFetchGenericRQScoringConfig = ({
  setIsLoading,
  queryId,
}: IuseFetchGenericRQScoringConfig) => {
  const [genericRQScoringConfig, setGenericRQScoringConfig] =
    useState<IGenericRQScoringConfig | null>(null);

  useEffect(() => {
    if (queryId && queryId > 0) {
      setIsLoading(true);
      const fetchConfig = async () => {
        try {
          const result = await getGenericRQScoringConfigByQuery(queryId);
          setGenericRQScoringConfig(result);
        } catch (err) {
          setGenericRQScoringConfig(null);
        } finally {
          setIsLoading(false);
        }
      };
      fetchConfig();
    }
  }, [queryId]);

  return [genericRQScoringConfig];
};

export default useFetchGenericRQScoringConfig;
